var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"close"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":1},React.createElement("g",{"transform":"translate(-1329.000000, -45.000000)","stroke":"#A4A8B3","strokeWidth":"2"},React.createElement("g",{"transform":"translate(80.000000, 1.000000)"},React.createElement("g",{"transform":"translate(1236.000000, 30.000000)"},React.createElement("path",{"d":"M12,21.9096985 L32,22.0903015 M22.0903015,32 L21.9096985,12","transform":"translate(22.000000, 22.000000) rotate(-45.000000) translate(-22.000000, -22.000000) "})))))]);
}

Close.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 18 16","version":"1.1"};

module.exports = Close;

Close.default = Close;
